// extracted by mini-css-extract-plugin
export var dropdownButton = "_11-0";
export var fullWidthDropdownButton = "_11-1";
export var icon = "_11-3";
export var iconPlaceholder = "_11-2";
export var menuItemRow = "_11-5";
export var shortcutContainer = "_11-4";